import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIMITReview = {
    name: 'DS in Progress',
    imageUrl: '../../images/MITReview.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIMITPlanreview = {
    name: 'DS in Progress',
    imageUrl: '../../images/MITPlanreview.png',
    imageSize: "99%",
    bradius: 20,
  };


export const MITReview = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Mitigation Review</b><br/><br/>
      Mitigation review provides a review of any type of mitigation plan, whether open or 
      closed and historical. The purpose of the My Mitigation Plans section is to highlight 
      exactly what mitigation plans are assigned to you, what progress has been made, and 
      to provide further details of any particular plan.
      </div>
      <div style={helpimg}>
      <img
        src={UIMITReview.imageUrl}
        alt={'Image of ' + UIMITReview.name}
        style={{
          width: UIMITReview.imageSize,
          borderRadius: UIMITReview.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const MITPlanreview = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Individual Plan Review</b><br/><br/>
      Click on a specific mitigation name or the view button to see a summary with useful indicators 
      like total assigned targets and items, and the plan progress percentage. You can also click on 
      the View all Actions button to see the specific actions taken by the plan assignee. 
      </div>
      <div style={helpimg}>
      <img
        src={UIMITPlanreview.imageUrl}
        alt={'Image of ' + UIMITPlanreview.name}
        style={{
          width: UIMITPlanreview.imageSize,
          borderRadius: UIMITPlanreview.bradius,
        }}
      />
      </div>
    </div>
  );
};
